/* JLA-005: mobile sticky Add-to-Cart bar. Mirrors native button state via MutationObserver
   instead of reimplementing it. Submits via requestSubmit() (not .click()) to avoid a scroll-
   jump, since the native button is off-screen while this bar is visible. */
(function () {
  // Variant ID for this Shoplift test. Control: 019f9463-74cc-7a11-9603-2d1492be32f7 (not
  // used here — isHypothesisActive only needs the variant's own ID).
  var hypothesisId = '019f9463-7c5b-70b2-81fb-2ddfdad46c98';

  function pushEvent(eventName) {
    if (window.dataLayer) {
      window.dataLayer.push({ event: eventName });
    }
  }

  function setup() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    if (!stickyBar) return;

    var formId = stickyBar.getAttribute('data-product-form-id');
    var form = document.getElementById(formId);
    if (!form) return;

    var nativeBtn = form.querySelector('.pdp-main-btn');
    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (!nativeBtn || !stickyBtn) return;

    // Diagnostic tracking, sticky vs. native usage — no prior analytics existed on this button.
    nativeBtn.addEventListener('click', function () {
      pushEvent('native_atc_click');
    });

    var scrollTopBtn = document.querySelector('.scroll-to-top');
    var scrollTopOriginalBottom = null;
    var reducedMotion = Boolean(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );

    function adjustScrollTopButton(show) {
      if (!scrollTopBtn) return;
      if (scrollTopOriginalBottom === null) {
        scrollTopOriginalBottom = window.getComputedStyle(scrollTopBtn).bottom;
        // Set once, matching the sticky bar's own transition timing so both move together.
        if (!reducedMotion) {
          scrollTopBtn.style.transition = 'bottom 0.14s cubic-bezier(0.16, 1, 0.3, 1)';
        }
      }
      if (show) {
        var barHeight = stickyBar.offsetHeight;
        scrollTopBtn.style.bottom = 'calc(' + scrollTopOriginalBottom + ' + ' + barHeight + 'px)';
      } else {
        scrollTopBtn.style.bottom = scrollTopOriginalBottom;
      }
    }

    function showBar() {
      stickyBar.classList.add('is-visible');
      adjustScrollTopButton(true);
    }

    function hideBar() {
      stickyBar.classList.remove('is-visible');
      adjustScrollTopButton(false);
    }

    // --bs-mainHeader-height is static for this site's header config — read once, not per-scroll.
    var headerHeight = 0;
    function readHeaderHeight() {
      headerHeight =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--bs-mainHeader-height')
        ) || 0;
    }
    readHeaderHeight();

    // Direct position check, rAF-throttled — IntersectionObserver's batching added jitter.
    var scrollTicking = false;

    function checkButtonPosition() {
      scrollTicking = false;
      var rect = nativeBtn.getBoundingClientRect();
      // Both edges checked, not just "scrolled away above" — else a tall hero/gallery that
      // starts the button below the fold would never trigger the bar.
      var isNativeBtnVisible = rect.bottom > headerHeight && rect.top < window.innerHeight;
      if (isNativeBtnVisible) {
        hideBar();
      } else {
        showBar();
      }
    }

    function onScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(checkButtonPosition);
    }

    var resizeTicking = false;
    function onResize() {
      if (resizeTicking) return;
      resizeTicking = true;
      requestAnimationFrame(function () {
        resizeTicking = false;
        readHeaderHeight();
        checkButtonPosition();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    checkButtonPosition();
    // Recheck after `load` — the theme's own sticky-header settles asynchronously and can
    // race our initial synchronous check.
    window.addEventListener('load', checkButtonPosition, { once: true });

    function syncState() {
      stickyBtn.disabled = nativeBtn.disabled;
      stickyBtn.classList.toggle('loading', nativeBtn.classList.contains('loading'));
      var nativeText = nativeBtn.querySelector('.add-text');
      var stickyText = stickyBtn.querySelector('.add-text');
      if (nativeText && stickyText) {
        stickyText.textContent = nativeText.textContent;
      }
    }

    var stateObserver = new MutationObserver(syncState);
    stateObserver.observe(nativeBtn, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });
    syncState();

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      // Disable optimistically — the observer mirror isn't instant, a fast double-tap could
      // slip through otherwise.
      stickyBtn.disabled = true;
      pushEvent('sticky_atc_click');
      if (form.requestSubmit) {
        form.requestSubmit(nativeBtn);
      } else {
        nativeBtn.click();
      }
    });
  }

  if (!window.shoplift) {
    // Shoplift script didn't load — fail safe to Control, same fallback pattern as JLA-004.
    return;
  }
  window.shoplift
    .isHypothesisActive(hypothesisId)
    .catch(function () {
      return false;
    })
    .then(function (showVariant) {
      if (showVariant) setup();
    });
})();
